import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";

const DuplicateFileDataLibrary = ({ Show, Hide, Title, getEDCLupDataLibrary, fileData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [previousFileName, setPreviousFileName] = useState("");
  const [previousFileLabel, setPreviousFileLabel] = useState("");
  const [type, setType] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileLabel, setFileLabel] = useState("");
  const [error, setError] = useState("");
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const duplicateDataEDCLupFileAndDataset = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Change Duplicate of this File?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, duplicate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.studyId = studyId;
        userData.fileId = fileData?.uniqueId;
        userData.name = fileName;
        userData.label = fileLabel;
        userData.type = type;
        userData.mode = StudyMode;
        let data = await studyEDCLupReportingServices.duplicateDataEDCLupFileAndDataset(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEDCLupDataLibrary();
          setFileName("")
          setFileLabel("")
          setType("")
          setError("")
          Hide()
        }
      }
    });
  };

  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setPreviousFileName(fileData?.name);
    setPreviousFileLabel(fileData?.label);
    setFileName(fileData?.name);
    setFileLabel(fileData?.label);
    setType(fileData?.type);
  }, [fileData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              File Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              value={fileName}
              onChange={(e) => {
                setFileName(e.target.value);
                validateFileTitle(e.target.value);
              }}
              placeholder="Enter File Name"
              className={previousFileName === fileName && "border-danger"}
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small letters,
                underScore, and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              File Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              value={fileLabel}
              onChange={(e) => setFileLabel(e.target.value)}
              placeholder="Enter File Label"
              className={previousFileLabel === fileLabel && "border-danger"}
              required
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              Select Library{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setType(e.target.value)}
              value={type}
              required
            >
              <option selected={type === ""} value="">Select Library</option>
              <option selected={type === "Analysis"} value="Analysis">Analysis</option>
              <option selected={type === "Standard"} value="Standard">Standard</option>
              <option selected={type === "Raw"} value="Raw">Raw</option>
              <option selected={type === "Temp"} value="Temp">Temp</option>
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            disabled={(buttonLoader || !fileName || !fileLabel || !type || (previousFileName === fileName) || (previousFileLabel === fileLabel) || error)}
            title={Title}
            className="updateProfile"
            onClick={() => {
              duplicateDataEDCLupFileAndDataset();
            }}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Duplicating...
              </div>
            ) : (
              "Duplicate"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default DuplicateFileDataLibrary;
